(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function normalize(str) {
      return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function initShopMegamenu() {
      var megamenus = document.querySelectorAll('[data-shop-megamenu]');
      if (!megamenus.length) return;

      megamenus.forEach(function (megamenu) {
        var trigger = normalize(megamenu.getAttribute('data-trigger'));
        if (!trigger) return;

        var header = megamenu.closest('.header-wrapper') || megamenu.parentElement;
        if (!header) return;

        var menuItems = header.querySelectorAll('.header__menu-item, .menu-drawer__menu-item');
        var targets = [];
        menuItems.forEach(function (item) {
          var textEl = item.querySelector('span') || item;
          if (normalize(textEl.textContent) === trigger) {
            targets.push(item);
          }
        });
        if (!targets.length) return;

        var isMobile = function () { return window.matchMedia('(max-width: 989px)').matches; };

        var closeTimer = null;
        var open = function () {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          megamenu.classList.add('is-open');
          megamenu.setAttribute('aria-hidden', 'false');
        };
        var scheduleClose = function () {
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            megamenu.classList.remove('is-open');
            megamenu.setAttribute('aria-hidden', 'true');
            closeTimer = null;
          }, 150);
        };

        var toggle = function () {
          if (megamenu.classList.contains('is-open')) {
            if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
            megamenu.classList.remove('is-open');
            megamenu.setAttribute('aria-hidden', 'true');
          } else {
            open();
          }
        };

        var drawerItem = null;
        targets.forEach(function (target) {
          var details = target.closest('details');
          var isDrawerItem = target.classList.contains('menu-drawer__menu-item');
          if (isDrawerItem) drawerItem = target;

          if (details && !isDrawerItem) {
            target.addEventListener('click', function (e) { e.preventDefault(); });
          }

          if (!target.querySelector('.shop-megamenu__trigger-arrow')) {
            var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            arrow.setAttribute('class', 'icon icon-caret shop-megamenu__trigger-arrow');
            arrow.setAttribute('viewBox', '0 0 14 8');
            arrow.setAttribute('fill', 'none');
            arrow.setAttribute('focusable', 'false');
            arrow.setAttribute('aria-hidden', 'true');
            arrow.innerHTML = '<path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
            target.classList.add('shop-megamenu__trigger');
            target.appendChild(arrow);
          }

          if (!isDrawerItem) {
            target.addEventListener('mouseenter', function () { if (!isMobile()) open(); });
            target.addEventListener('mouseleave', function () { if (!isMobile()) scheduleClose(); });
            target.addEventListener('focus', function () { if (!isMobile()) open(); });
            target.addEventListener('focusout', function (e) {
              if (isMobile()) return;
              if (!target.contains(e.relatedTarget) && !megamenu.contains(e.relatedTarget)) {
                scheduleClose();
              }
            });
          }
        });

        var originalParent = megamenu.parentElement;
        var originalNextSibling = megamenu.nextElementSibling;
        var drawerSlot = null;

        function relocate() {
          if (isMobile()) {
            if (drawerItem && !drawerSlot) {
              var drawerLi = drawerItem.closest('li');
              if (drawerLi) {
                drawerSlot = drawerLi;
                drawerLi.insertAdjacentElement('afterend', megamenu);
                megamenu.classList.add('is-open');
                megamenu.setAttribute('aria-hidden', 'false');
              }
            }
          } else {
            if (drawerSlot) {
              if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
                originalParent.insertBefore(megamenu, originalNextSibling);
              } else {
                originalParent.appendChild(megamenu);
              }
              drawerSlot = null;
              megamenu.classList.remove('is-open');
              megamenu.setAttribute('aria-hidden', 'true');
            }
          }
        }
        relocate();
        window.addEventListener('resize', function () {
          if (relocate._t) clearTimeout(relocate._t);
          relocate._t = setTimeout(relocate, 150);
        });

        var setTriggerOpen = function (isOpen) {
          targets.forEach(function (t) { t.classList.toggle('is-open', isOpen); });
        };
        var observer = new MutationObserver(function () {
          setTriggerOpen(megamenu.classList.contains('is-open'));
        });
        observer.observe(megamenu, { attributes: true, attributeFilter: ['class'] });

        megamenu.addEventListener('mouseenter', function () { if (!isMobile()) open(); });
        megamenu.addEventListener('mouseleave', function () { if (!isMobile()) scheduleClose(); });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            megamenu.classList.remove('is-open');
            megamenu.setAttribute('aria-hidden', 'true');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShopMegamenu);
    } else {
      initShopMegamenu();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
